import { EmptyState, PageHeader } from '@didto/ui';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="d-page">
      <PageHeader eyebrow="404" title="Not found" />
      <EmptyState
        title="That page does not exist"
        action={
          <Link to="/" className="d-btn d-btn--primary d-btn--sm">
            Back to the dashboard
          </Link>
        }
      />
    </div>
  );
}
